export default __webpack_public_path__ + "static/media/WhatsApp Image 2023-06-13 at 22.28.54.fe301f45.jpeg";